// Chart.js is ~170 KB minified and only the dashboard pages draw charts, so it lives in
// its own chunk (esbuild code splitting, see package.json) and is fetched the first time
// a chart controller connects. Registration happens once per page load.
let chartPromise = null

export function loadChart() {
  chartPromise ||= import("chart.js").then((mod) => {
    mod.Chart.register(
      mod.BarController, mod.BarElement, mod.LineController, mod.LineElement, mod.PointElement,
      mod.CategoryScale, mod.LinearScale, mod.Tooltip, mod.Legend, mod.Filler
    )
    return mod.Chart
  })
  return chartPromise
}
